namespace GeniuzPOS.PosShift {
    export interface PsVatRefundRateForm {
        VatRateNo: Serenity.IntegerEditor;
        PurchaseFrom: Serenity.DecimalEditor;
        PurchaseTo: Serenity.DecimalEditor;
        RoundedRefund: Serenity.DecimalEditor;
        RefundPc: Serenity.DecimalEditor;
        RefundFg: Serenity.RadioButtonEditor;
    }

    export class PsVatRefundRateForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.PsVatRefundRate';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsVatRefundRateForm.init)  {
                PsVatRefundRateForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.RadioButtonEditor;

                Q.initFormType(PsVatRefundRateForm, [
                    'VatRateNo', w0,
                    'PurchaseFrom', w1,
                    'PurchaseTo', w1,
                    'RoundedRefund', w1,
                    'RefundPc', w1,
                    'RefundFg', w2
                ]);
            }
        }
    }
}
